<template>
  <span class="sortable-layout" @click="triggle()">
    <el-tooltip :disabled="sortTooltip === ''" placement="top" effect="light">
      <div slot="content">
        {{ sortTooltip }}
      </div>
      <span v-if="orderByClause && sortField === orderByClause.split(' ')[0]">
        <i
          :class="
            orderByClause && orderByClause.split(' ')[1] === 'asc'
              ? 'el-icon-sort-up'
              : 'el-icon-sort-down'
          "
        ></i>
      </span>
      <span v-else> <i class="el-icon-sort"></i> </span>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  props: ["sortField", "orderByClause"],
  computed: {
    sortTooltip() {
      // 若指定排序参数与 sortField 相同时
      if (
        this.orderByClause &&
        this.sortField === this.orderByClause.split(" ")[0]
      ) {
        if (this.orderByClause.split(" ")[1] === "desc") {
          // 若为递减
          return "大 → 小";
        } else if (this.orderByClause.split(" ")[1] === "asc") {
          // 若为递增
          return "小 → 大";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    triggle() {
      // 若指定排序参数与 sortField 不同时
      if (
        !this.orderByClause ||
        this.sortField !== this.orderByClause.split(" ")[0]
      ) {
        // 递减
        this.$emit("update:order-by-clause", this.sortField + " desc");
      } else if (this.orderByClause.split(" ")[1] === "desc") {
        // 递增
        this.$emit("update:order-by-clause", this.sortField + " asc");
      } else if (this.orderByClause.split(" ")[1] === "asc") {
        // 清空
        this.$emit("update:order-by-clause", "");
      }
      // 请求列表
      this.$emit("get-list");
    },
  },
};
</script>
<style scoped>
.sortable-layout {
  cursor: pointer;
  float: right;
}
.sortable-layout .el-icon-sort,
.sortable-layout .el-icon-sort-up,
.sortable-layout .el-icon-sort-down {
  color: #9c9c9c;
}
</style>


// WEBPACK FOOTER //
// src/views/components/SortableV2.vue